import StyledLink from 'components/StyledLink';
import styled from 'styled-components';
import { device } from '../../styles/stylesheets';

export const Container = styled.div`
  row-gap: 24px;
  column-gap: 24px;
  max-width: 100%;

  @media ${device.untilTablet} {
    grid-row-gap: 16px;
  }
`;

export const MoreCategory = styled(StyledLink)`
  display: block;
  clear: left;
  width: 100%;
  text-align: end;
`;
